import { Link } from 'react-router-dom';
import Logo from './Logo';

const LINKEDIN_URL = 'https://www.linkedin.com/in/sasho-cvetanoski/';
const GITHUB_URL = 'https://github.com/SashoCv';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-24 border-t border-white/10 bg-ink-950/60">
      <div className="container-page grid gap-10 py-14 md:grid-cols-4">
        <div className="md:col-span-2">
          <Link to="/" className="inline-flex items-center text-white">
            <Logo className="h-10 w-auto md:h-11" />
          </Link>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-white/60">
            We design and build custom software solutions — web platforms, SaaS products,
            internal tools, and AI-powered systems engineered to scale with your business.
          </p>
          <div className="mt-5 flex items-center gap-2">
            <a
              href={LINKEDIN_URL}
              target="_blank"
              rel="noreferrer"
              aria-label="Nexsol Labs on LinkedIn"
              className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white/70 transition hover:border-white/20 hover:bg-white/10 hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="h-4 w-4"
                aria-hidden="true"
              >
                <path d="M4.98 3.5a2.5 2.5 0 11-.02 5 2.5 2.5 0 01.02-5zM3 9h4v12H3V9zm7 0h3.8v1.7h.05c.53-1 1.83-2.05 3.77-2.05 4.03 0 4.78 2.65 4.78 6.1V21h-4v-5.4c0-1.29-.02-2.95-1.8-2.95-1.8 0-2.08 1.4-2.08 2.85V21H10V9z" />
              </svg>
            </a>
            <a
              href={GITHUB_URL}
              target="_blank"
              rel="noreferrer"
              aria-label="Nexsol Labs on GitHub"
              className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white/70 transition hover:border-white/20 hover:bg-white/10 hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="h-4 w-4"
                aria-hidden="true"
              >
                <path d="M12 .5C5.65.5.5 5.65.5 12c0 5.08 3.29 9.39 7.86 10.91.58.1.79-.25.79-.56v-2.18c-3.2.7-3.87-1.37-3.87-1.37-.52-1.33-1.28-1.69-1.28-1.69-1.04-.71.08-.7.08-.7 1.16.08 1.77 1.19 1.77 1.19 1.03 1.77 2.7 1.26 3.36.96.1-.75.4-1.26.73-1.55-2.55-.29-5.24-1.28-5.24-5.69 0-1.26.45-2.28 1.19-3.09-.12-.29-.52-1.46.11-3.04 0 0 .97-.31 3.19 1.18a11.1 11.1 0 015.81 0c2.22-1.49 3.19-1.18 3.19-1.18.63 1.58.23 2.75.11 3.04.74.81 1.19 1.83 1.19 3.09 0 4.42-2.7 5.4-5.27 5.68.41.36.78 1.06.78 2.15v3.18c0 .31.21.67.8.56C20.21 21.39 23.5 17.08 23.5 12 23.5 5.65 18.35.5 12 .5z" />
              </svg>
            </a>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-white">Company</h3>
          <ul className="mt-4 space-y-2 text-sm">
            <li>
              <Link to="/services" className="text-white/60 hover:text-white">
                Services
              </Link>
            </li>
            <li>
              <Link to="/projects" className="text-white/60 hover:text-white">
                Projects
              </Link>
            </li>
            <li>
              <Link to="/clients" className="text-white/60 hover:text-white">
                Clients
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-white/60 hover:text-white">
                About
              </Link>
            </li>
            <li>
              <Link to="/contact" className="text-white/60 hover:text-white">
                Contact
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-white">Get in touch</h3>
          <ul className="mt-4 space-y-2 text-sm">
            <li>
              <a
                href="mailto:sasocvetanoski@nexsollabs.com"
                className="break-all text-white/60 hover:text-white"
              >
                sasocvetanoski@nexsollabs.com
              </a>
            </li>
            <li className="text-white/50">Skopje, North Macedonia</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="container-page flex flex-col items-start justify-between gap-3 py-6 text-xs text-white/40 md:flex-row md:items-center">
          <p>© {year} Nexsol Labs. All rights reserved.</p>
          <p>Engineered with care.</p>
        </div>
      </div>
    </footer>
  );
}
